$( ".recharge-subscription-widget" ).insertAfter( ".total-price" );

 var swiper = new Swiper(".mySwiperr", {
      slidesPerView: 1,
      loop: true,
       autoplay: {
        delay: 5000,
        disableOnInteraction: false
         
      },    
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });

// homepage banner